/* unplugin-vue-components disabled */import script from "./technical-content-card.vue?vue&type=script&lang=js"
export * from "./technical-content-card.vue?vue&type=script&lang=js"

import "./technical-content-card.vue?vue&type=style&index=0&id=1a149120&lang=scss"

const __exports__ = script;

export default __exports__